import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { BUS_CHASSIS_PATH } from '../../../../config/paths';
import BusChassisDeleteButton from './BusChassisDeleteButton';

const BusChassisToolbar = ({ busChassisId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${BUS_CHASSIS_PATH}/${busChassisId}/edit`} />{' '}
      <BusChassisDeleteButton busChassisId={busChassisId} />
    </div>
  </ButtonToolbar>
);

BusChassisToolbar.propTypes = {
  busChassisId: PropTypes.number.isRequired,
};

export default BusChassisToolbar;